/**
 * @Description 小天才的一项评分及预估销售额
 */

import React, { useMemo } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import { XTCScoreType } from '../../ts-config';
import { beautifyTheLowHighObject, isNotEmpty } from '@lhb/func';

const ScoreFiveOwnScore: React.FC<{
  scoreType: XTCScoreType; // 评分类型,区分xtc与bbg
  score?: number; // 评分
  timeDimension: any; // 销售额预测时间单位类型
  salesAmountPredict: number; // 预测营业额
  wrapperClassName?: string; // 自定义组件整体classname
  salesPredict: number;
}> = ({
  scoreType,
  // https://confluence.lanhanba.com/pages/viewpage.action?pageId=172102595
  // score,
  timeDimension,
  salesAmountPredict,
  wrapperClassName = '',
  salesPredict,
}) => {

  const predictValue = useMemo(() => {
    const title = `预测年营业额`;
    const title2 = `预测年销量`;
    const res = {
      val: '',
      unit: '',
      title,
      title2,
      val2: '',
      unit2: '',
    };
    const hasAmountPredict = isNotEmpty(salesAmountPredict);
    if (hasAmountPredict) {
      const amountRes = beautifyTheLowHighObject(1, salesAmountPredict, 2, { low: '元', high: '万元', top: '亿元' });
      res.val = amountRes.val;
      res.unit = amountRes.unit;
    }
    const hasSalesPredict = isNotEmpty(salesPredict);
    if (hasSalesPredict) {
      const countRes = beautifyTheLowHighObject(1, salesPredict, 2, { low: '台', high: '万台', top: '亿台' });
      res.val2 = countRes.val;
      res.unit2 = countRes.unit;
    }
    return res;
  }, [timeDimension, salesAmountPredict]);

  return (
    <div className={cs([styles.scoreAndPredictWrapper, wrapperClassName])}>
      <div className={cs([styles.scorePredictItem])}>
        <div className={styles.predict}>
          <div className={styles.predictClear}>
            <div className={styles.predictLeft}>
              <div className={styles.predictNum}>
                <div className={styles.num}>{predictValue.val}</div>
                <div className={styles.unit}>{predictValue.unit}</div>
              </div>
              <div className={styles.predictDesc}>
                {predictValue.title}
              </div>
            </div>
            <div className={styles.predictRight}>
              <div className={styles.predictNum}>
                <div className={cs([styles.num, styles.num2])}>{predictValue.val2}</div>
                <div className={styles.unit}>{predictValue.unit2}</div>
              </div>
              <div className={styles.predictDesc}>
                {predictValue.title2}
              </div>
            </div>
          </div>
        </div>
        {/* <div className={styles.score}>{score}</div> */}
        <div className={styles.predictTag}>
          {scoreType === XTCScoreType.BBG ? '步步高' : '小天才'}
        </div>
      </div>
    </div>
  );
};

export default ScoreFiveOwnScore;
